import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { EntityRegisterView } from 'src/app/common-components/register/models/register-view';
import {
   SystemLogsAccountOption,
   SystemLogsAreaOption,
   SystemLogsSeverityOption,
   SystemLogsTypeOption,
} from '../../models/system-log-filter-option';
import { SystemLogPrivileges } from '../../models/system-log-privileges';
import { SystemLogOrderingOptions, SystemLogRegisterOptions } from '../../models/system-log-register-options';
import { LogRegisterListItem } from '../../models/system-log-register-results.model';
import { selectQuickFilters } from '../../state/system-log-register.reducer';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-system-log-register-view',
    styleUrls: ['./system-log-register-view.component.scss'],
    templateUrl: './system-log-register-view.component.html',
    standalone: false
})
export class SystemLogRegisterViewComponent extends EntityRegisterView<
   LogRegisterListItem,
   SystemLogRegisterOptions,
   SystemLogOrderingOptions
> {
   protected selectQuickFilters(): (state: object) => SystemLogRegisterOptions | null {
      return selectQuickFilters;
   }

   protected override onQuickFiltersInit(quickFilters: SystemLogRegisterOptions): void {
      if (quickFilters) {
         this.selectedAccount = quickFilters.account;
         this.selectedSeverityType = quickFilters.severity;
         this.selectedSystemLogType = quickFilters.systemLogType;
         this.selectedSystemLogArea = quickFilters.systemLogArea;
         this.startDate = quickFilters.startDate ? new Date(quickFilters.startDate) : null;
         this.endDate = quickFilters.endDate ? new Date(quickFilters.endDate) : null;
      }
   }

   @Input() systemLogPrivileges: SystemLogPrivileges;

   @Input() accountId: number | null;

   @Output() openDialog = new EventEmitter<{ callLogs: any }>();

   @Output() openLogDialog = new EventEmitter<{ callLogs: any }>();

   selectedSeverityType: SystemLogsSeverityOption | undefined = undefined;

   selectedSystemLogType: SystemLogsTypeOption | undefined = undefined;

   selectedSystemLogArea: SystemLogsAreaOption | undefined = undefined;

   selectedAccount: SystemLogsAccountOption | undefined = undefined;

   startDate: Date | null = null;
   endDate: Date | null = null;

   onDateQuickFilterChange(event) {
      this.quickFilterChange.emit(event);
   }

   getRouterLink(id: number): string {
      return `/system-log-register/${id}`;
   }

   onSeverityTypeSelected(severityOption: SystemLogsSeverityOption) {
      this.registerOptions = { ...this.registerOptions, severity: severityOption };
      this.quickFilterChange.emit(this.registerOptions);
   }

   onSystemLogTypeSelected(typeOption: SystemLogsTypeOption) {
      this.registerOptions = { ...this.registerOptions, systemLogType: typeOption };
      this.quickFilterChange.emit(this.registerOptions);
   }

   onSystemLogAreaSelected(areaOption: SystemLogsAreaOption) {
      this.registerOptions = { ...this.registerOptions, systemLogArea: areaOption };
      this.quickFilterChange.emit(this.registerOptions);
   }

   onAccountSelected(accountOption: SystemLogsAccountOption) {
      this.registerOptions = { ...this.registerOptions, account: accountOption };
      this.quickFilterChange.emit(this.registerOptions);
   }

   onOpenDialog(callLogs: any) {
      this.openDialog.emit({ callLogs: callLogs });
   }

   onOpenLogDialog(callLogs: any) {
      this.openLogDialog.emit({ callLogs: callLogs });
   }
}
